/**
 * om-preorder-note.js
 *
 * Companion to the "preorder_note" PDP block (snippets/om-preorder-note.liquid).
 *
 * product-info.js re-fetches the whole section on every option change and
 * copies a fixed list of ids (Price, Inventory, Preorder, Badges, ...) into
 * the live DOM. The ETA note is not on that list, so this subscriber copies
 * the fetched #PreorderNote-<section> (innerHTML + hidden state) after the
 * variantChange event, which product-info.js publishes last. Variant-level
 * dates therefore refresh without touching product-info.js.
 *
 * Known limit: for unavailable option combinations product-info.js returns
 * before publishing, so the note keeps its last state (the button already
 * reads "Unavailable" in that case).
 */
(function () {
  'use strict';

  if (window.__omPreorderNoteInit) return;
  window.__omPreorderNoteInit = true;

  function init() {
    if (typeof subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) return;

    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;

      var fetched = data.html.getElementById('PreorderNote-' + data.sectionId);
      var live = document.getElementById('PreorderNote-' + data.sectionId);
      if (!fetched || !live) return;

      live.innerHTML = fetched.innerHTML;
      live.classList.toggle('hidden', fetched.classList.contains('hidden'));
    });
  }

  // Deferred, so the DOM is parsed and theme.dev.js (subscribe) has already run: start now rather than on
  // DOMContentLoaded, which Cookiebot auto-blocking holds back for seconds.
  if (document.readyState === 'loading' || typeof subscribe !== 'function') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
